<template>
  <div>
    <fieldset :disabled="$attrs.disabled">
      <div class="card mt-5 p-md-4">
        <div class="card-body">
          <div class="card-title text-green">
            <img
              src="@/assets/images/icons/picture.svg"
              alt=""
            >
            <span class="b-inline-block ml-1">Main Event Image</span>
          </div>
          <div class="card-text">
            <span class="form-section-description">
              This is the first image attendees will see at the top of your listing.
            </span>
          </div>
          <!-- Image Uploader -->
          <profile-picture-uploader
            file-type="event_main_image"
            label="Add Image"
            accept="image/jpeg, image/png"
            rules="size:10240"
            :cropper="true"
            :stencil-props="{
              aspectRatio: 16/9,
            }"
            :disabled="$attrs.disabled"
            description="Recommended image size: 1600 x 900px - Maximum file size: 10MB - supported image files: JPEG or PNG"
            :image.sync="event.main_image"
          />
        </div>
      </div>
      <div class="card mt-5 p-md-4">
        <div class="card-body px-0">
          <div class="card-title text-green">
            <span class="b-inline-block">Summary</span>
          </div>
          <div class="card-text">
            <span class="form-section-description">
              Grab people's attention with a short description about your event. Attendees will see this at the top of
              your event page.
            </span>
          </div>
          <text-input
            id="event-summary"
            name="Summary"
            rules="max:250|required"
            :text.sync="event.summary"
          />
        </div>
        <div class="card-title text-green">
          <span class="b-inline-block ml-1">Description</span>
        </div>
        <div class="card-text">
          <span class="form-section-description">
            Add more details to your event like your schedule, sponsors, or featured guests
          </span>
        </div>
        <rich-text-editor
          name="Description"
          rules="max:5000"
          :disabled="$attrs.disabled"
          :description.sync="event.description"
        />
        <b-row>
          <b-col md="9">
            <!-- Event Description Images -->
            <files-uploader
              v-if="!$attrs.disabled"
              label="Description Images"
              file-type="event_images"
              accept="image/jpeg, image/png"
              rules="size:10240|image-aspect-ratio:16,9"
              :multiple="true"
              :files.sync="event.images"
            />
            <!-- Images Preview -->
            <images-preview
              :images.sync="event.images"
              :disabled="$attrs.disabled"
            />
          </b-col>
          <b-col>
            <b-button
              class="d-inline-block mb-2"
              variant="outline-primary"
              @click="isVideoVisible=true"
            >
              <feather-icon icon="YoutubeIcon" />
              Add Video
            </b-button>
            <!-- Video URL -->
            <text-input
              v-show="event.video_url || isVideoVisible"
              id="event-video-url"
              ref="video_url"
              name="Video Url"
              rules="youtube-url"
              :text.sync="event.video_url"
            />
            <b-embed
              v-if="event.video_url&&$refs.video_url && $refs.video_url.$children[0].flags.passed"
              type="iframe"
              :src="event.video_url.replace('/watch?v=', '/embed/')"
            />
          </b-col>
        </b-row>
      </div>
    </fieldset>
  </div>
</template>

<script>
import ProfilePictureUploader from '../FormInputs/ProfilePictureUploader.vue'
import RichTextEditor from '../FormInputs/RichTextEditor.vue'
import TextInput from '../FormInputs/TextInput.vue'
import FilesUploader from '../FormInputs/FilesUploader.vue'
import ImagesPreview from '../FormInputs/ImagesPreview.vue'

export default {
  name: 'EventInputs',
  components: {
    RichTextEditor,
    TextInput,
    ProfilePictureUploader,
    FilesUploader,
    ImagesPreview,
  },
  props: {
    event: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      isVideoVisible: false,
    }
  },
}
</script>

<style>

</style>
